import { Avatar, IconButton, List, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { AUTHORITIES } from "@/config/constants";
import { useAppSelector } from "@/config/store";
import { IEdoChat } from "@/shared/model/edo-chat.model";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { hasAnyAuthority } from "@/shared/auth/private-route";
import { Plus } from "lucide-react";
import { CreateChat } from "./CreateChat";

interface ChatHeaderBarProps {
  onEdit: (entity: IEdoChat) => void;
  showAccount?: boolean;
}

const ChatHeaderBar = (props: ChatHeaderBarProps) => {
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );

  const { onEdit: handleOnEdit, showAccount = true } = props;

  return (
    <>
      {showAccount ? (
        <>
          <List>
            <ListItem className="flex cursor-default items-center gap-3 px-4 py-3">
              <ListItemIcon>
                <Avatar className="h-10 w-10">
                  {account.firstName[0]}{account.lastName[0]}
                </Avatar>
              </ListItemIcon>
              <ListItemText primary={`${account.firstName} ${account.lastName}`} />
            </ListItem>
          </List>
          <hr className="border-[var(--color-mockup-border)]" />
        </>
      ) : null}
      <div className="flex items-center justify-between p-2.5">
        <div className="flex-1 pr-2">
          <CreateChat />
        </div>
        {hasAnyAuthority(account.roles, [AUTHORITIES.ROLE_ADMIN, AUTHORITIES.ROLE_TEACHER, AUTHORITIES.ROLE_SUPPORT_TEACHER, AUTHORITIES.ROLE_VICE]) ? (
          <IconButton onClick={() => handleOnEdit(null)} aria-label="Nuovo gruppo">
            <Plus className="h-5 w-5" />
          </IconButton>
        ) : null}
      </div>
    </>
  );
};

export default ChatHeaderBar;
